// term: the org's program labels (hooks/useTerminology); the copy names programs in the org's words
export const getProgrammaticTypeDetailsMap = (term) => {
    const ccm = term('ccm');
    const rpm = term('rpm');
    return {
        NO_CARE: {
            name: 'No Care',
            description:
                'A task will be created for any active (enrolled) patient with zero care sessions. The task will be created once per qualified patient per month.'
        },
        LESS_THAN_5_MIN_CCM: {
            name: `Less Than 5 ${ccm}`,
            description: `Less than 5. ${ccm} enrolled patients who are within 5 minutes of the next billable code as seen on Programmed Tasks Alerts. This task will not be retriggered for the same patient if a "Less than 5 ${ccm}" programmatic task is still open.`
        },
        LESS_THAN_5_MIN_RPM: {
            name: `Less Than 5 ${rpm}`,
            description: `Less than 5. ${rpm} enrolled patients who are within 5 minutes of the next billable code as seen on Programmed Tasks Alerts. This task will not be retriggered for the same patient if a "Less than 5 ${rpm}" programmatic task is still open.`
        },
        LESS_THAN_10_MIN_CCM: {
            name: `Less Than 10 ${ccm}`,
            description: `Less than 10. ${ccm} enrolled patients who are within 10 minutes of the next billable code as seen on Programmed Tasks Alerts. This task will not be retriggered for the same patient if a "Less than 10 ${ccm}" programmatic task is still open.`
        },
        '99490_OPPORTUNITY': {
            name: '99490 Opportunity',
            description: `99490 Opportunity. ${ccm} enrolled patients who are within 20 minutes of 99490 billable code as seen on Programmed Tasks Alerts. This task will not be retriggered for the same patient if a "99490 Opportunity" programmatic task is still open.`
        },
        CUSTOM_PROTOCOLS: {
            name: 'Custom Protocols',
            description: ''
        },
        NO_FINALIZED_CARE_PLAN: {
            name: 'No Finalized Care Plan',
            description: `Tasks are created for patients who are enrolled in ${ccm} but do not have a finalized care plan. This task will be created only once for a patient.`
        },
        UNVERIFIED_MANUAL_FILL: {
            name: 'Unverified Manual Fill',
            description:
                'Tasks are created when a manually added fill is newer than every imported fill for a medication that was previously verified as imported. Verify the fill with the pharmacy and delete it from the medication if it is not valid. This task is created only once per fill.'
        }
    };
};
